import api from "./api";
import { FormTemplate, FormServiceRef } from "../types/forms";

interface ApiForm {
  id: number;
  title: string;
  uuid: string;
  description: string;
  sections: any[];
  business_services: Array<{
    id: number;
    name: string;
    slug: string;
  }>;
  sunbeds?: any[];
  draft?: boolean;
  saved?: boolean;
}

interface ApiFormsResponse {
  success?: boolean;
  forms: ApiForm[];
}

const mapApiFormToFormTemplate = (form: ApiForm): FormTemplate => {
  return {
    id: String(form.id),
    uuid: form.uuid,
    title: form.title,
    description: form.description,
    sections: form.sections || [],
    fields: [],
    saved: true,
    draft: false,

    // CORRECT: use FormServiceRef, no casting
    services: form.business_services.map<FormServiceRef>((s) => ({
      id: String(s.id),
      title: s.name,
      name: s.name,
      slug: s.slug,
    })),

    sunbeds: [],
  };
};

export const getForms = async (): Promise<FormTemplate[]> => {
  const response = await api.get<ApiFormsResponse>("/admin/forms");

  const payload = response.data;

  if (!payload?.forms || !Array.isArray(payload.forms)) {
    return [];
  }

  return payload.forms.map(mapApiFormToFormTemplate);
};
